import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { PopupsService } from "./components/popups/popups.service";
import {
  trigger,
  transition,
  style,
  animate,
  state,
} from "@angular/animations";
import { PopupsComponent } from "./components/popups/popups.component";
import { Subscription } from "rxjs";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatIconRegistry } from "@angular/material/icon";
import { AppConfig } from "./app.config";
import { UsuarioPreferenciasService } from "./services/data-services/usuario.preferencias.service";
import { DialogoService } from "./components/popups/dialogo/dialogo.service";
import { DialogoComponent } from "./components/popups/dialogo/dialogo.component";

import { StatusService } from "./services/status.service";
import { PopupCarregamentoComponent } from "./components/popups/popup-carregamento/popup-carregamento.component";
import { SignalrService } from "./services/signalr.service";
import { Icons, Icon } from "./models/ui/icon";
import { CheckForUpdateService } from "./services/check-for-update.service";
import { DomSanitizer } from "@angular/platform-browser";
import { AuthService } from "./modules/shared/services/auth.service";
import Clarity from "@microsoft/clarity";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";
import { StorageService } from "./services/storage.service";
import { ErrorHandlerService } from "./services/errorHandler.service";
import { MENSAGEM_SESSAO_EXPIRADA } from "./modules/shared/resources/messages";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  animations: [
    trigger("transitionPopup", [
      state("true", style({ opacity: "1" })),
      state("false", style({ opacity: "0" })),
      transition("* => *", animate("300ms ease")),
    ]),
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild(PopupsComponent) popupsComponent: PopupsComponent;
  showPopup: boolean;

  dialogRefDialogo: MatDialogRef<DialogoComponent>;

  isLoggedIn: boolean;
  wasLoggedIn: boolean;
  carregarAplicativo: boolean;
  popupSincronizacaoAberta: boolean;

  private indicadorCarregamento: MatDialogRef<PopupCarregamentoComponent>;

  private workingMessage: string;
  private sAvailable: Subscription;
  private sUser: Subscription;
  private sVisible: Subscription;
  private sMessage: Subscription;
  private sMensagensProgresso: Subscription;
  private sModel: Subscription;
  private sUsuarioPreferencias: Subscription;

  constructor(
    private auth: AuthService,
    private popupsService: PopupsService,
    private usuarioPreferenciasService: UsuarioPreferenciasService,
    private dialogoService: DialogoService,
    private statusService: StatusService,
    private signalrService: SignalrService,
    private snackBar: MatSnackBar,
    private checkForUpdateService: CheckForUpdateService,
    private dialog: MatDialog,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private router: Router,
    private storageService: StorageService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  ngOnInit() {
    Icons.forEach((icon) =>
      Icon.Register(icon.description, this.iconRegistry, this.sanitizer)
    );

    this.checkForUpdateService.initialize();
    this.storageService.connectDatabases();

    if (this.auth.userIsLoggedIn()) {
      if (!this.usuarioPreferenciasService?.getConfiguracoesvalue?.id) {
        // Há token mas os dados do usuário não estão no navegador (ex.: o
        // download falhou no login) > desloga e avisa. O restante do
        // ngOnInit precisa continuar para os avisos funcionarem.
        this.auth
          .logoff()
          .catch((erro) => this.errorHandlerService.handleError(erro));
        this.statusService.setMessage(MENSAGEM_SESSAO_EXPIRADA);
      } else {
        Clarity.init(environment.projectId);

        Clarity.identify(
          this.usuarioPreferenciasService.getConfiguracoesvalue.id,
          undefined,
          undefined,
          undefined
        );
      }
    }

    this.sUsuarioPreferencias = this.usuarioPreferenciasService
      .getConfiguracoes()
      .subscribe((config) => {
        this.carregarAplicativo = config ? true : false;
      });

    this.sUser = this.auth.getToken().subscribe(() => {
      this.wasLoggedIn = this.isLoggedIn;
      this.isLoggedIn = this.auth.userIsLoggedIn();
      let refreshed = false;

      if (typeof this.wasLoggedIn === "undefined") {
        this.wasLoggedIn = this.isLoggedIn;
        refreshed = true;
      }

      if (this.isLoggedIn && this.wasLoggedIn) {
        if (refreshed) {
          this.signalrService.conectar();
        }
      } else if (this.isLoggedIn && !this.wasLoggedIn) {
        // this.signalrService.conectar();
      }
    });
    this.sVisible = this.popupsService.getVisible().subscribe((visible) => {
      this.showPopup = this.auth.userIsLoggedIn() && visible;
    });

    this.sModel = this.dialogoService.getModel().subscribe((m) => {
      const abrir = () => {
        this.dialogRefDialogo = this.dialog.open(DialogoComponent, {
          width: AppConfig.larguraIndicadorPopup,
          data: m,
          disableClose: true,
        });
      };

      const fechar = () => {
        if (this.dialogRefDialogo) {
          this.dialogRefDialogo.close();
        }
      };

      if (m) {
        abrir();
      } else {
        fechar();
      }
    });

    this.sMensagensProgresso = this.statusService
      .getMensagensProgresso()
      .subscribe((pilhaMensagens) => {
        if (!pilhaMensagens || pilhaMensagens.length === 0) {
          this.indicadorCarregamento?.close();
        }

        let msg = "";

        if (pilhaMensagens && pilhaMensagens.length > 0) {
          msg = pilhaMensagens[pilhaMensagens.length - 1]
            ? pilhaMensagens[pilhaMensagens.length - 1].message
            : "";
        }

        if (msg === this.workingMessage || (!msg && !this.workingMessage)) {
          return;
        }

        if (!this.workingMessage && msg) {
          this.indicadorCarregamento = this.dialog.open(
            PopupCarregamentoComponent,
            {
              disableClose: true,
            }
          );
        }

        this.workingMessage = msg;
      });

    this.sMessage = this.statusService.getMessage().subscribe((error) => {
      if (!error) {
        return;
      }

      this.snackBar.open(error, "OK", {
        duration: 5000,
      });
    });
  }

  ngOnDestroy(): void {
    this.sAvailable.unsubscribe();
    this.sUser.unsubscribe();
    this.sVisible.unsubscribe();
    this.sMessage.unsubscribe();
    this.sMensagensProgresso.unsubscribe();
    this.sModel.unsubscribe();
    this.sUsuarioPreferencias.unsubscribe();
  }

  public tryClosePopup(evt: any): void {
    this.popupsComponent.tryClose(evt);
  }
}
